// extracted by mini-css-extract-plugin
export default {"treeArea":"ModelTree_treeArea__J7qVd","treeBox":"ModelTree_treeBox__xr6K2"};